<!-- OnboardingLayout Template - Feature: 013-shell-navigation -->
<!-- Simplified layout for onboarding: Header only, NO navigation -->
<!-- Header outside wrapper to match old main-layout structure -->
<app-header></app-header>

<div class="onboarding-layout bg-light">
  <!-- Skip Link for Accessibility -->
  <a href="#main-content" class="skip-link" [attr.aria-label]="'SHELL.SKIP_TO_CONTENT' | translate">
    {{ 'SHELL.SKIP_TO_CONTENT' | translate }}
  </a>

  <!-- Main Content Area -->
  <main id="main-content" class="onboarding-layout__content" role="main" tabindex="-1">
    <div class="onboarding-layout__content-inner">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
